var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
/**
 * Any metadata that we don't want the client to be exposed to
 */
var fragment = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment internalTenantMetadata on TenantMetadata {\n        comments\n    }\n"], ["\n    fragment internalTenantMetadata on TenantMetadata {\n        comments\n    }\n"])));
export var toString = fragment.loc.source.body;
export default fragment;
var templateObject_1;
